

import { Box } from '@mui/material';
import React from "react";
import {
    required, SelectInput, TextInput, useDataProvider,
    useNotify
} from "react-admin";
import { useFormContext, useWatch } from 'react-hook-form';
import 'handsontable/dist/handsontable.full.css';
import { Button } from '@mui/material';


export const DriverNIDInput = ({ source, onDriverNotFound }) => {
    const { setValue, getValues } = useFormContext();
    const notify = useNotify();
    const dataProvider = useDataProvider();
  
    const handleSearch = async () => {
      const nid = getValues(source);
  
      if (nid) {
        try {
          const response = await dataProvider.getList('ods_plan_history', {
            filter: { 'nid_number@_eq': nid},
  
            
            pagination: { page: 1, perPage: 1 },
            sort: { field: 'id', order: 'DESC' },
  
          });
          const data = response.data;
          if (data && data.length > 0) {
            const driver = data[0];
            setValue('driver_id', driver.id);
            setValue('driver_meta_data', {
              nid_number: driver.nid_number,
              name: driver.name,
              nationality: driver.nationalitie,
              mobileno: driver.mobileno,
              sub_day: driver.sub_day,
              operatortype: driver.operatortype,
              sub_operator: driver.sub_operator,
              operator_id: driver.operator_id,
              contract_id: driver.contract_id,
              driver_license_type: driver.driver_license_type,
              license_expiration_date: driver.license_expiration_date,
              driving_card_end_date: driver.driving_card_end_date,
              is_ods: true,
            });
      
  
                   // Step 3: If `sub_day` exists, fetch all operation plans for that day.
          if (driver.sub_day) {
            const operationPlansResponse = await dataProvider.getList('ods_plan_history', {
              filter: {
               'sub_day@_eq': driver.sub_day,
                'nid_number@_eq': nid,
              },
              pagination: { page: 1, perPage: 100 }, // Adjust pagination as needed.
            });
  
            const operationPlans = operationPlansResponse.data;
  
            //console.log(operationPlans);
  
            // Step 4: Set the `operation_plan` key with the fetched plans.
            setValue('operation_plan', operationPlans);
          }
  
  
  
          } else {
            notify('فشل التعرف علي السائق فى الخطة التشغيلية  - يرجي اضافة السائق يدويا.', { type: 'warning' });
            if (onDriverNotFound) {
              onDriverNotFound();
            }
          }
        } catch (error) {
          notify('Error fetching driver data', { type: 'error' });
        }
      } else {
        notify('فضلا ادخل رقم الهوية الخاص بالسائق.', { type: 'warning' });
      }
    };
  
    return (
      <Box display="flex" alignItems="stretch" gap={2} width="100%">
      <TextInput 
        source={source} 
        fullWidth 
        sx={{ 
          '& .MuiInputBase-root': { height: '56px' } // Matches the default button height 
        }} 
      />
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleSearch} 
        sx={{ height: '56px', whiteSpace: 'nowrap' }} // Same height as TextInput
      >
        الاستعلام عن بيانات السائق بالهوية
      </Button>
    </Box>
    
    
    );
  };
  
  
  const handleDriverNotFound = () => {
    //setOpenCreateDriverDialog(true);
  };
  
  
  export const useWatchDriverInput = (name) => {
    const { control } = useFormContext();
  
    // Watch the 'editingDriverMeta' field
    const editingDriverMeta = useWatch({
      control,
      name: 'editingDriverMeta',
      defaultValue: false,
    });
  
    const driverMetaData = useWatch({
      control,
      name: 'driver_meta_data',
      defaultValue: null,
    });
  
  
    return {
      disabled: !editingDriverMeta, // Disable input if 'editingDriverMeta' is false
      driverMetaData: driverMetaData, // Disable input if 'editingDriverMeta' is false
      control,
    };
  };
  
  
  export const useWatchVehicleInput = (name) => {
    const { control } = useFormContext();
  
    // Watch the 'editingVehicleMeta' field
    const editingVehicleMeta = useWatch({
      control,
      name: 'editingVehicleMeta',
      defaultValue: false,
    });
  
    const VehicleMetaData = useWatch({
      control,
      name: 'Vehicle_meta_data',
      defaultValue: null,
    });
  
  
    return {
      disabled: !editingVehicleMeta, // Disable input if 'editingVehicleMeta' is false
      VehicleMetaData: VehicleMetaData, // Disable input if 'editingVehicleMeta' is false
      control,
    };
  };





  export const TextInputWatchDriver=(meta) => {
    const { disabled,driverMetaData } = useWatchDriverInput('editingDriverMeta'); // Use the custom hook
    const {source_name, index, is_required}=meta;
  
    if (!driverMetaData) {
      return null; // Render nothing if driverMetaData is undefined or null
    }
    // Return the TextInput component with the necessary props
    return (
     <TextInput
        fullWidth
        validate={is_required ? [required()] : undefined}
        source={source_name}
        key={index}
        disabled={disabled}
      />
    );
  }
  
  export const IsOdsChangeWatchDriver=(meta) => {
    const { disabled,driverMetaData } = useWatchDriverInput('editingDriverMeta'); // Use the custom hook
    const {source_name, index, is_required}=meta;
  
    if (!driverMetaData) {
      return null; // Render nothing if driverMetaData is undefined or null
    }
    // Return the TextInput component with the necessary props
    return (
      <SelectInput
      fullWidth
      validate={is_required ? [required()] : undefined}
      source={source_name}
      key={index}
      disabled={true} // Enable or disable based on your requirements
      choices={[
        { id: true, name: 'نعم' },
        { id: false, name: 'لا' },
      ]}
      optionText="name"
      optionValue="id"
    />
  
    );
  }
  